import axios from 'axios';

const API_URL = window.env.API_URL;
const ACCESS_TOKEN = window.env.ACCESS_TOKEN;

function authHeaders() {
  return {
    Authorization: `Bearer ${window.localStorage.getItem(ACCESS_TOKEN)}`,
  };
}

/**
 * GET /films/uuid/:uuid — full film row for previews (thumbnails, name, warranty text).
 *
 * @param {string} uuid
 * @returns {Promise<Record<string, unknown>|null>}
 */
export async function fetchFasaraFilmByUuid(uuid) {
  if (uuid == null || String(uuid).trim() === '') {
    return null;
  }
  try {
    const response = await axios.get(
      `${API_URL}/films/uuid/${encodeURIComponent(String(uuid).trim())}`,
      { headers: authHeaders() },
    );
    const body = response.data;
    return body?.data ?? body ?? null;
  } catch (err) {
    console.error('fetchFasaraFilmByUuid', err);
    return null;
  }
}
